import { render, staticRenderFns } from "./taskBan.vue?vue&type=template&id=093f8f41&scoped=true"
import script from "./taskBan.vue?vue&type=script&lang=js"
export * from "./taskBan.vue?vue&type=script&lang=js"
import style0 from "./taskBan.vue?vue&type=style&index=0&id=093f8f41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093f8f41",
  null
  
)

export default component.exports